export default __webpack_public_path__ + "static/banner-circuit-mobile-71945b171260df616feee4780086cd9e.svg";